import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ShippingDetailsCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const ShippingDetailsCardHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	padding: 2rem;
	border-bottom: 1px solid var(--border-color);
`;

export const ShippingDetailsCompanyHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 2rem;
	border-bottom: 1px solid var(--border-color);
`;

export const LogoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 2rem;
`;

export const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const ShippingDetailsCardContent = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	padding: 2rem;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const DetailItem = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: auto;
`;

export const DetailItemWithIcon = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 1rem;

	> .icon {
		background-color: var(--background-3);
		padding: 0.75rem;
		border-radius: 50%;
		margin-bottom: auto;
	}
`;

export const DetailItemLabel = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	height: 3rem;
`;

export const SlaDetailsCardContent = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 2rem;
	padding: 2rem 2rem 2rem ${(props) => (props.leftPadded ? '4rem' : '2rem')};

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const PriceContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Divider = styled.span`
	display: flex;
	height: 1px;
	width: 100%;
	background-color: var(--border-color);
`;

export const DividerContainer = styled.span`
	display: flex;
	padding: 0 2rem;
`;

export const ExpectedDescriptions = styled.div`
	& > .typography {
		margin-bottom: 2rem;
	}
`;

export const PriceDetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	line-height: 2.5rem;
`;

export const BlackText = styled.span`
	color: var(--black);
`;
